import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
    faFacebook,
    faTwitter,
    faInstagram,
} from "@fortawesome/free-brands-svg-icons";

export default {
    name: 'Mediabar',
    components: {
        FontAwesomeIcon
    },
    data() {
        return {
            twitter: faTwitter,
            facebook: faFacebook,
            instagram: faInstagram
        }
    }
}